var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAddr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27609_85588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 4.81919C1.83325 3.17013 3.26967 1.83331 5.04159 1.83331C6.8135 1.83331 8.24992 3.17013 8.24992 4.81919C8.24992 6.45532 7.22593 8.36453 5.62828 9.04728C5.25584 9.20644 4.82733 9.20644 4.45489 9.04728C2.85724 8.36453 1.83325 6.45532 1.83325 4.81919Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.8192C13.75 14.1701 15.1864 12.8333 16.9583 12.8333C18.7302 12.8333 20.1667 14.1701 20.1667 15.8192C20.1667 17.4553 19.1427 19.3645 17.545 20.0473C17.1726 20.2064 16.7441 20.2064 16.3716 20.0473C14.774 19.3645 13.75 17.4553 13.75 15.8192Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8751 16.0417C17.8751 16.5479 17.4647 16.9583 16.9584 16.9583C16.4522 16.9583 16.0417 16.5479 16.0417 16.0417C16.0417 15.5354 16.4522 15.125 16.9584 15.125C17.4647 15.125 17.8751 15.5354 17.8751 16.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 5.04167C5.95833 5.54793 5.54793 5.95833 5.04167 5.95833C4.53541 5.95833 4.125 5.54793 4.125 5.04167C4.125 4.53541 4.53541 4.125 5.04167 4.125C5.54793 4.125 5.95833 4.53541 5.95833 5.04167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 3.58331C10.4476 3.58331 9.99991 4.03103 9.99991 4.58331C9.99991 5.1356 10.4476 5.58331 10.9999 5.58331V3.58331ZM10.9999 17.4166L11.707 18.1238C12.0975 17.7332 12.0975 17.1001 11.707 16.7095L10.9999 17.4166ZM15.7717 7.96336L16.3086 8.80702L15.7717 7.96336ZM6.22809 14.0366L6.76496 14.8803H6.76496L6.22809 14.0366ZM10.332 15.3345C9.9415 14.944 9.30833 14.944 8.91781 15.3345C8.52728 15.7251 8.52728 16.3582 8.91781 16.7488L10.332 15.3345ZM8.91781 18.0845C8.52728 18.4751 8.52728 19.1082 8.91781 19.4988C9.30833 19.8893 9.9415 19.8893 10.332 19.4988L8.91781 18.0845ZM14.7875 3.58331H10.9999V5.58331H14.7875V3.58331ZM10.9999 16.4166H7.21235V18.4166H10.9999V16.4166ZM15.2349 7.1197L5.69121 13.1929L6.76496 14.8803L16.3086 8.80702L15.2349 7.1197ZM11.707 16.7095L10.332 15.3345L8.91781 16.7488L10.2928 18.1238L11.707 16.7095ZM10.2928 16.7095L8.91781 18.0845L10.332 19.4988L11.707 18.1238L10.2928 16.7095ZM7.21235 16.4166C6.37866 16.4166 6.06159 15.3279 6.76496 14.8803L5.69121 13.1929C3.29978 14.7148 4.37774 18.4166 7.21235 18.4166V16.4166ZM14.7875 5.58331C15.6212 5.58331 15.9382 6.6721 15.2349 7.1197L16.3086 8.80702C18.7001 7.28519 17.6221 3.58331 14.7875 3.58331V5.58331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27609_85588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAddr);
export default __webpack_public_path__ + "static/media/ManageAddr.0cf00462f9914625ce0e76a769136a7e.svg";
export { ForwardRef as ReactComponent };